import { StyledAccordionProps } from "./Accordion.interface";
import styled from "styled-components";

export const StyledAccordion = styled.div<StyledAccordionProps>`
  display: flex;
  flex-direction: column;
  position: relative;
`;

export const StyledAccordionHeader = styled.div<{ mb?: string }>`
  align-items: center;
  cursor: pointer;
  display: flex;
  flex: 1;
  margin-bottom: ${({ mb }) => mb || '0'};
`;

export const StyledAccordionBody = styled.div<StyledAccordionProps>`
  background-color: ${({backgroundColor }) => backgroundColor || 'inherit' };
  display: ${({ state }) => state === 'close' ? 'none' : 'flex'};
  flex: 1;
  flex-direction: ${({ bodyDirection }) => bodyDirection || 'column'};
`;

export const StyledAccordionArrow = styled.i`
  margin-left: auto;
  position: absolute;
  right: 0;
  top: 4px;
`;